import React from 'react';
import { useTranslation } from 'react-i18next';
import { IonButton } from '@ionic/react';
import { ForgottenpwdInstruction, ForgottenpwdOptionsWrapper } from 'pages/forgottenpwd/Forgottenpwd.styled';

interface ForgottenpwdOptionsProps {
  onEmailOptionSelected: () => void;
  onTrainerOptionSelected: () => void;
  onBack?: () => void;
}

const ForgottenpwdOptions: React.FC<ForgottenpwdOptionsProps> = ({
  onEmailOptionSelected,
  onTrainerOptionSelected,
  onBack,
}) => {
  const { t } = useTranslation('translation');

  return (
    <ForgottenpwdOptionsWrapper>
      <ForgottenpwdInstruction>
        {t('forgottenpwd.options.instruction')}
      </ForgottenpwdInstruction>
      
      <div className="options-buttons">
        <IonButton 
          expand="block" 
          fill="solid" 
          className="option-button email-option"
          onClick={onEmailOptionSelected}
        >
          <div className="option-content">
            <div className="option-title">
              {t('forgottenpwd.options.email.title')}
            </div>
            <div className="option-description">
              {t('forgottenpwd.options.email.description')}
            </div>
          </div>
        </IonButton>

        <IonButton 
          expand="block" 
          fill="outline" 
          className="option-button trainer-option"
          onClick={onTrainerOptionSelected}
        >
          <div className="option-content">
            <div className="option-title">
              {t('forgottenpwd.options.trainer.title')}
            </div>
            <div className="option-description">
              {t('forgottenpwd.options.trainer.description')}
            </div>
          </div>
        </IonButton>
      </div>

      {onBack && (
        <IonButton
          fill="clear"
          size="small"
          onClick={onBack}
          className="back-button"
        >
          {t('common.back')}
        </IonButton>
      )}
    </ForgottenpwdOptionsWrapper>
  );
};

export default ForgottenpwdOptions;